import NormalizedRuleAction, {
	ruleActionToNormalizedRuleAction,
	normalizedRuleActionToRuleAction,
} from "./normalized-rule-action";
import { VelavuRule, VelavuRuleCategory } from "velavu-js-api";

export interface NormalizedRule {
	name: string;
	description: string;
	enabled: boolean;
	condition: string;
	priority: number;
	action: NormalizedRuleAction;
}

export function velavuRuleToNormalizedRule(rule: VelavuRule): NormalizedRule {
	return {
		name: rule.name ?? "",
		description: rule.description ?? "",
		enabled: rule.enabled,
		condition: rule.condition,
		priority: rule.priority,
		action: ruleActionToNormalizedRuleAction(rule.action),
	};
}

export function normalizedRuleToVelavuRule(
	state: NormalizedRule,
): Pick<
	VelavuRule,
	| "name"
	| "description"
	| "enabled"
	| "condition"
	| "priority"
	| "action"
	| "category"
> {
	return {
		condition: state.condition,
		priority: state.priority,
		category: VelavuRuleCategory.User,
		action: normalizedRuleActionToRuleAction(state.action),
		enabled: state.enabled,
		name: state.name,
		description: state.description,
	};
}
